import { t } from 'ttag'
import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import H2VideoPlayer from '@main/components/H2VideoPlayer'
import { logOccupationVideoView } from '@main/actions/occupationProfile'
import { SLB10S, WHITE } from '@h2/components/colors'
import videoGreen from '@h2/assets/svg/icons/videoGreen.svg'

const ThumbnailList = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  gap: 5px;
  margin-top: 15px;
`
const ThumbnailListItem = styled.li`
  width: calc(20% - 5px);
  min-width: calc(20% - 5px);
  max-width: calc(20% - 5px);
  height: 125px;
  flex: 1;
`
const FullButton = styled.button`
  width: 100%;
  height: 100%;
  border: 0;
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-color: ${WHITE};
  padding: 0;
  border-bottom: ${({ isActive }) => (isActive ? `7px solid ${SLB10S}` : `none`)};
  box-shadow: ${({ isActive }) => (isActive ? `0px 0px 5px ${SLB10S}` : `none`)};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.7)};
  ${({ mediaType }) =>
    mediaType === 'VIMEO' &&
    `
    position: relative;
    &::after {
     display: block;
      position: absolute; 
      width: 100%; 
      height: 100%;
      content: '';
      background-image: url(${videoGreen});
      background-repeat: no-repeat;
      align-items: center;
      background-position: center;
      top: 0;
      opacity: .6;
      background-size: 40%;
    }
  `}
`
const MainImage = styled.img`
  width: 100%;
  margin-bottom: 25px;
`
const MediaSlideshow = ({ media, onetSoc }) => {
  const pictureTypes = ['PICTURE', 'AWSPICTURE']
  const sortedMedia = () => {
    return [...media].sort((first, second) => {
      if (first.mediaType === 'VIMEO' && second.mediaType !== 'VIMEO') {
        return -1
      }

      if (second.mediaType === 'VIMEO' && first.mediaType !== 'VIMEO') {
        return 1
      }

      return 0
    })
  }
  const [selectedImage, setSelectedImage] = useState(sortedMedia()[0])
  const dispatch = useDispatch()
  const firstPic = () => {
    const newImagesPrefix = 'videos/'
    const occupationMedia = media
      .filter(file => pictureTypes.includes(file.mediaType))
      .sort((fileA, fileB) => {
        const firstNew = fileA.fileName.indexOf(newImagesPrefix) === 0
        const secondNew = fileB.fileName.indexOf(newImagesPrefix) === 0
        const isEqual = firstNew === secondNew

        if (isEqual) {
          return fileB.fileName.localeCompare(fileA.fileName)
        }

        if (firstNew) {
          return -1
        }

        return 1
      })

    return occupationMedia.length > 0 ? (occupationMedia[0] || {}).url : null
  }
  const logVideoCompletion = useCallback(() => {
    dispatch(logOccupationVideoView(onetSoc, selectedImage.fileName))
  }, [dispatch, onetSoc, selectedImage.fileName])
  const fixUrl = url => {
    return url //dynamicValues.isProduction ? url : `https://app.headed2.com${url}`
  }

  return (
    <div id="mediaslideshow">
      <div className="main-img-wrap">
        <div className="main-img shown">
          {(() => {
            if (pictureTypes.includes(selectedImage.mediaType)) {
              return (
                <MainImage
                  src={fixUrl(selectedImage.url)}
                  alt={t`Workers performing tasks related to the job`}
                />
              )
            }

            if (selectedImage.mediaType === 'VIMEO') {
              return (
                <H2VideoPlayer
                  allowSeek={true}
                  id={`vplayer--${selectedImage.url}`}
                  poster={fixUrl(firstPic())}
                  onComplete={logVideoCompletion}>
                  <source type="video/mp4" src={fixUrl(selectedImage.url)} />
                  {selectedImage.captionUrl && (
                    <track
                      default
                      kind="subtitles"
                      srcLang="en"
                      label="English"
                      src={fixUrl(selectedImage.captionUrl)}
                    />
                  )}
                </H2VideoPlayer>
              )
            }
          })()}
        </div>
      </div>
      <ThumbnailList>
        {sortedMedia().map((pic, idx) => {
          return (
            <ThumbnailListItem key={`media-${idx}`}>
              <FullButton
                isActive={selectedImage === pic}
                mediaType={pic.mediaType}
                background={fixUrl(
                  pictureTypes.includes(pic.mediaType) ? pic.url : firstPic()
                )}
                onClick={() => {
                  setSelectedImage(pic)
                }}
              />
            </ThumbnailListItem>
          )
        })}
      </ThumbnailList>
    </div>
  )
}

export { MediaSlideshow }
